import { FolderRole, LibraryFolder, FolderUserRole } from '@/library/library_types.ts'

export function isFolderShared(folder: LibraryFolder): boolean {
  const activeRoles = folder.folder_roles?.filter(role => role.role !== FolderRole.NONE) || []
  return activeRoles?.length > 1
}

export function getFolderOwnerRole(folder: LibraryFolder | undefined): FolderUserRole | undefined {
  return folder?.folder_roles?.find(role => role.role === 'owner')
}

export function getFolderOwnerUuid(folder: LibraryFolder | undefined): string | undefined {
  return getFolderOwnerRole(folder)?.user_uuid
}